import { useEffect, useState } from "react";
import { Download, Loader2, FileCheck2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { SIGNED_FILE_PREVIEW } from "@/constants/testIds";
import { toast } from "sonner";

export function SignedFilePreviewDialog({ docId, title, open, onOpenChange }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [contentType, setContentType] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open || !docId) return;
    let currentUrl = null;
    setLoading(true);
    api
      .get(`/signable-documents/${docId}/signed-file`, { responseType: "blob" })
      .then((response) => {
        currentUrl = URL.createObjectURL(response.data);
        setBlobUrl(currentUrl);
        setContentType(response.data.type);
      })
      .catch(() => toast.error("No se pudo abrir el documento firmado."))
      .finally(() => setLoading(false));
    return () => {
      if (currentUrl) URL.revokeObjectURL(currentUrl);
      setBlobUrl(null);
    };
  }, [open, docId]);

  const handleDownload = () => {
    if (!blobUrl) return;
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = title || "documento_firmado";
    a.click();
  };

  const isImage = contentType?.startsWith("image/");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid={SIGNED_FILE_PREVIEW.dialog} className="bg-bone max-w-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-1.5"><FileCheck2 className="w-4 h-4 text-emerald-600" /> {title}</DialogTitle>
          <DialogDescription>Vista previa del documento firmado en físico.</DialogDescription>
        </DialogHeader>

        <div className="bg-white rounded-xl border border-petroleum/10 h-[60vh] flex items-center justify-center overflow-hidden">
          {loading && <Loader2 className="w-6 h-6 text-petroleum animate-spin" />}
          {!loading && blobUrl && isImage && <img src={blobUrl} alt={title} className="max-h-full max-w-full object-contain" />}
          {!loading && blobUrl && !isImage && <iframe src={blobUrl} title="Vista previa del documento firmado" className="w-full h-full" />}
        </div>

        <Button data-testid={SIGNED_FILE_PREVIEW.downloadButton} onClick={handleDownload} disabled={!blobUrl} className="w-full bg-petroleum rounded-full">
          <Download className="w-4 h-4 mr-2" /> Descargar
        </Button>
      </DialogContent>
    </Dialog>
  );
}
